import IService from '../IService';
import app from 'app';

export default IService.extend({
  createNew(data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl('/api/v1/draftStoryTemplates'),
        type: 'POST',

        contentType: 'application/json',
        data: JSON.stringify({
          categories: [],
          ...data,
        }),

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },

        dataType: 'json',
        success(response) {
          if (Object.getOwnPropertyDescriptor(response, 'storyId')) {
            resolve(response.storyId);
          } else {
            reject({ error: 'BAD_RESPONSE' });
          }
        },
      });
    });
  },

  categoriesForStory(storyId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl(`/api/v1/draftStoryTemplates/${storyId}/metadata`),
        type: 'GET',
        data: { storyId },

        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            resolve({});
          }
        },

        dataType: 'json',
        success(response) {
          if (Object.getOwnPropertyDescriptor(response, 'categoryIds')) {
            resolve(response);
          } else {
            reject({ error: 'BAD_RESPONSE' });
          }
        },
      });
    });
  },

  convertStory2Template: IService.synchronized(function (data) {
    data = Object.assign(
      {
        storyId: null,
        categoryIds: [],
        channelId: null,
      },
      data
    );
    const rv = new $.Deferred();

    $.ajax({
      url: app.apiUrl(`/api/v1/draftStoryTemplates/${data.storyId}/metadata`),
      type: 'POST',

      contentType: 'application/json',
      data: JSON.stringify(data),

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      success: () => {
        rv.resolve();
      },
    });

    return rv.promise();
  }),

  updateTemplateMetadata(data) {
    data = Object.assign(
      {
        storyId: null,
        categoryIds: [],
        channelId: null,
      },
      data
    );
    const rv = new $.Deferred();

    $.ajax({
      url: app.apiUrl(`/api/v1/draftStoryTemplates/${data.storyId}/metadata`),
      type: 'PUT',

      contentType: 'application/json',
      data: JSON.stringify(data),

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      success: () => {
        rv.resolve();
      },
    });

    return rv.promise();
  },

  convertTemplate2Story: IService.synchronized(function (storyId) {
    const rv = new $.Deferred();

    $.ajax({
      url: app.apiUrl(`/api/v1/draftStoryTemplates/${storyId}/metadata`),
      type: 'DELETE',

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      success: () => {
        rv.resolve();
      },
    });

    return rv.promise();
  }),

  createDraftStoryTemplateFromDraftStoryTemplate: IService.synchronized(
    function ({
      storyId,
      newTitle,
      destProgrammerId,
      storyStartPoint,
      brandId,
      themeId,
    }) {
      const deferred = new $.Deferred();

      console.log('\u26A1createDraftStoryTemplateFromDraftStoryTemplate\u26A1');
      $.ajax({
        url: app.apiUrl(`/api/v1/draftStoryTemplates/${storyId}`),
        type: 'POST',

        contentType: 'application/json',
        data: JSON.stringify({
          newTitle,
          destProgrammerId,
          storyStartPoint,
          destBrandId: brandId,
          destThemeId: themeId,
        }),

        error: (jqXHR, textStatus) => {
          if ('abort' === textStatus) {
            deferred.reject(this.createError(jqXHR));
          } else {
            app.dialog
              .serverError(this.createError(jqXHR))
              .then(deferred.reject);
          }
        },

        dataType: 'json',
        success: (res) => {
          deferred.resolve(res);
        },
      });

      return deferred.promise();
    }
  ),
});
